// Standard locale used by Stripe, [IETF language tag](https://en.wikipedia.org/wiki/IETF_language_tag)
const countryLocale: Record<string, string> = {
  ca: 'fr-CA',
  de: 'de-DE',
  dk: 'da-DK',
  fi: 'fi-FI',
  fr: 'fr-FR',
  nb: 'nb-NO',
  nl: 'nl-NL',
  nn: 'nn-NO',
  no: 'nb-NO',
  se: 'sv-SE',
  uk: 'en-GB',
  us: 'en-US',
};

export default countryLocale;
